import apiClient from './apiClient';

const list = (data) => (Array.isArray(data) ? data : data?.results || data?.data || []);

const ratePlanService = {
  // Plans (the response carries los_discounts; PATCH with
  // los_discounts replaces the plan's tier set).
  getPlans: async () => list(await apiClient.get('/rates/plans/')),
  createPlan: (data) => apiClient.post('/rates/plans/', data),
  updatePlan: (id, data) => apiClient.patch(`/rates/plans/${id}/`, data),
  removePlan: (id) => apiClient.del(`/rates/plans/${id}/`),
  preview: (id, params) => apiClient.get(`/rates/plans/${id}/preview/`, params),

  // Pricing rules
  getRules: async (ratePlanId) =>
    list(await apiClient.get('/rates/rules/', { rate_plan: ratePlanId })),
  createRule: (data) => apiClient.post('/rates/rules/', data),
  updateRule: (id, data) => apiClient.put(`/rates/rules/${id}/`, data),
  removeRule: (id) => apiClient.del(`/rates/rules/${id}/`),

  // Seasons
  getSeasons: async () => list(await apiClient.get('/rates/seasons/')),
  createSeason: (data) => apiClient.post('/rates/seasons/', data),
  updateSeason: (id, data) => apiClient.patch(`/rates/seasons/${id}/`, data),
  removeSeason: (id) => apiClient.del(`/rates/seasons/${id}/`),

  getRoomTypes: async () => list(await apiClient.get('/v1/room-types')),
};

export default ratePlanService;
